import { Fold, ArrowRight } from "@element-plus/icons-vue";
export default {
  data: function data() {
    return {
      xuan: true //用于判断顶部面包屑图标的旋转

    };
  },
  components: {
    Fold: Fold
  },
  setup: function setup() {
    return {
      ArrowRight: ArrowRight
    };
  },
  methods: {
    hides: function hides() {
      this.$emit('isCollapse', this.xuan);
      this.xuan = !this.xuan; //面包屑左侧图标旋转
    }
  }
};